/** @format */

import React, {useContext, useReducer, useEffect, useCallback} from 'react';
import {useRouter} from 'next/router';

import {pageUrl, requestData} from '@utils/product';
import {reducer} from '@reducers/product/list';
import {api} from '@utils/api';

const BrandContext = React.createContext();
export const BrandProvider = ({children, props}) => {
	const [state, dispatch] = useReducer(reducer, {
		filters: [],
		brands: [],
		loading: true,
	});

	const router = useRouter();

	const loadBrands = useCallback(async () => {
		const {brands} = await api({
			url: '/product/brands',
			method: 'POST',
			data: {
				...requestData({
					filters: {
						category: props.filters.category,
						retailer: props.filters.retailer,
						name: props.filters.name,
						// eslint-disable-next-line babel/camelcase
						price_from: props.filters.price_from,
						// eslint-disable-next-line babel/camelcase
						price_to: props.filters.price_to,
						shipping: props.filters.shipping,
					},
					category: props.category,
					retailerId: props.retailerId,
				}).filter,
			},
		});
		brands.sort(function (a, b) {
			if (a.value.name.toLowerCase() < b.value.name.toLowerCase()) {
				return -1;
			}
			if (a.value.name.toLowerCase() > b.value.name.toLowerCase()) {
				return 1;
			}
			return 0;
		});
		let filters = [];

		if (props.filters.brand) {
			let selected = props.filters.brand.split('|');
			filters = brands
				.filter(b => selected.indexOf(b._id.toString()) !== -1)
				.map(item => ({
					_id: item._id,
					label: item.value.name,
					type: 'brand',
				}));
		}

		dispatch({
			type: 'SET_DATA',
			data: {
				filters,
				brands,
				loading: false,
			},
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		props.filters.retailer,
		props.filters.category,
		props.filters.price_from,
		props.filters.price_to,
		props.filters.name,
		props.category,
		props.retailerId,
		props.filters.shipping,
		props.filters.brand,
	]);

	useEffect(() => {
		if (!props.isAuction) loadBrands();
	}, [loadBrands, props.isAuction]);

	const updateFilter = (filters, push = false) => {
		dispatch({
			type: 'SET_DATA',
			data: {
				filters,
			},
		});

		if (push) {
			let brand = null;
			for (let i = 0; i < filters.length; i++) {
				const filter = filters[i];
				if (brand) {
					brand += `|${filter._id}`;
				} else {
					brand = filter._id;
				}
			}

			let query = props.filters;
			if (brand) {
				query.brand = brand;
			} else {
				delete query.brand;
			}

			delete query.page;

			router.push({
				pathname: pageUrl(props),
				query,
			});
		}
	};

	return (
		<BrandContext.Provider
			value={{
				brands: state.brands,
				filters: state.filters,
				loading: state.loading,
				updateFilter,
			}}
		>
			{children}
		</BrandContext.Provider>
	);
};

export function useBrand() {
	const context = useContext(BrandContext);
	if (context === undefined) {
		throw new Error('useBrand must be used within a BrandProvider');
	}
	return context;
}
